import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { OfferSection } from './components/OfferSection';
import { PremiumIncludesSection } from './components/PremiumIncludesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TransformSection } from './components/TransformSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-[var(--bg)] text-[var(--text)]" data-id="element-0" data-mp="23utcc5hxu4bu">
      <main data-id="element-1" data-mp="3ikqz80j1f669">
        <HeroSection data-id="element-2" data-mp="3ij64oawq3n8e" />
        <ProblemSection data-id="element-3" data-mp="3ijpcuzwkmx98" />
        <TomosSection data-id="element-4" data-mp="3mljat0fdtn5p" />
        <BonosSection data-id="element-5" data-mp="3ml1234bj9ggw" />
        <OfferSection data-id="element-6" data-mp="3mk85uxa7a9d0" />
        <PremiumIncludesSection data-id="element-7" data-mp="3mjq45l4rr2xp" />
        <TestimonialsSection data-id="element-8" data-mp="3rcj6y3gog175" />
        <FaqSection data-id="element-9" data-mp="3rdas0kcnegj6" />
        <CostSection data-id="element-10" data-mp="3rcsxbs5mwadd" />
        <GuaranteeSection data-id="element-11" data-mp="3reltgdimfc74" />
        <TransformSection data-id="element-12" data-mp="6hqtghuuhen" />
        <FinalCtaSection data-id="element-13" data-mp="4wylxj0jajy" />
      </main>
      <Footer data-id="element-14" data-mp="82ohezguggq" />
    </div>;
}